import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { verifyEmail } from '../../utils/queries';
import AuthCard, { FormError, FormSuccess } from './AuthCard';

// Landing page for the link emailed by /register. Verifies on load.
export default function VerifyEmail() {
	const [searchParams] = useSearchParams();
	const token = searchParams.get('token') || '';
	const email = searchParams.get('email') || '';
	const linkIsValid = Boolean(token && email);

	const [state, setState] = useState({ loading: linkIsValid, done: '', error: '' });
	// StrictMode runs effects twice in development; the token is single-use,
	// so a second request would report the link as invalid.
	const requested = useRef(false);

	useEffect(() => {
		if (!linkIsValid || requested.current) return;
		requested.current = true;

		verifyEmail({ email, token }).then((response) =>
			setState({
				loading: false,
				done: response?.error ? '' : response?.data || 'Your email has been verified. You can now sign in.',
				error: response?.error || '',
			}),
		);
	}, [linkIsValid, email, token]);

	return (
		<AuthCard title='Verify your email' subtitle={email || undefined}>
			{!linkIsValid && <FormError message='This verification link is invalid or incomplete.' />}
			{state.loading && <p className='text-center text-sm text-gray-600'>Verifying...</p>}
			<FormError message={state.error} />
			<FormSuccess message={state.done} />

			{!state.loading && (
				<p className='text-center text-sm text-gray-600'>
					<Link to='/login' className='text-pi-red hover:underline'>
						{state.done ? 'Sign in' : 'Back to sign in'}
					</Link>
				</p>
			)}
		</AuthCard>
	);
}
